import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


class Home extends Component {
	
    render() {
	    return (
			
			<div className="medium-12 columns">
				
				<section className="slider">
					<OwlCarousel className="owl-theme" items={1}
						loop={true}
						nav={true}
						responsiveClass={true}
						responsive={{
						'0': { items: 1, nav: false },
						'768': { items: 1, nav: false },
						'990': { nav: true },
						}}
						navText={[
						'<i class="fa fa-arrow-left" aria-hidden="true"></i>',
						'<i class="fa fa-arrow-right" aria-hidden="true"></i>',
						]}
						dots={false}>
						<div className="item">
							<div className="single-slider overlay">
								<div className="container">
									<div className="row">
										<div className="col-lg-7 col-sm-7">
											<div className="text">
												<small>Welcome to Redixpress</small>
												<h1>Redi Xpress Your Full Service Medical & Crowdsource Delivery Service
												</h1>
												<div className="button">
													<a href="https://redixpresslogistics.com/courier/public/" className="btn">Get Started</a>
												</div>
											</div>
										</div>
										<div className="col-lg-5 col-sm-5">
											<img src="img/slider-1.png" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="item">
							<div className="single-slider overlay">
								<div className="container">
									<div className="row">
										<div className="col-lg-7 col-sm-7">
											<div className="text">
												<small>Welcome to Redixpress</small>
												<h1>Same day Medical Delivery</h1>
												<div className="button">
													<a href="https://redixpresslogistics.com/courier/public/" className="btn">Get Started</a>
												</div>
											</div>
										</div>
						
										<div className="col-lg-5 col-sm-5">
											<img src="img/slider-2.png" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="item">
							<div className="single-slider overlay">
								<div className="container">
									<div className="row">
										<div className="col-lg-7 col-sm-7">
											<div className="text">
												<small>Welcome to Redixpress</small>
												<h1>Scheduled Medical Delivery Services</h1>
												<div className="button">
													<a href="https://redixpresslogistics.com/courier/public/" className="btn">Get Started</a>
												</div>
											</div>
										</div>
										<div className="col-lg-5 col-sm-5">
											<img src="img/slider-1.png" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="item">
							<div className="single-slider overlay">
								<div className="container">
									<div className="row">
										<div className="col-lg-7 col-sm-7">
											<div className="text">
												<small>Welcome to Redixpress</small>
												<h1>Medical Supplies</h1>
												<div className="button">
													<a href="https://redixpresslogistics.com/courier/public/" className="btn">Get Started</a>
												</div>
											</div>
										</div>
						
										<div className="col-lg-5 col-sm-5">
											<img src="img/slider-2.png" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="item">
							<div className="single-slider overlay">
								<div className="container">
									<div className="row">
										<div className="col-lg-7 col-sm-7">
											<div className="text">
												<small>Welcome to Redixpress</small>
												<h1>Medical Prescription Delivery</h1>
												<div className="button">
													<a href="https://redixpresslogistics.com/courier/public/" className="btn">Get Started</a>
												</div>
											</div>
										</div>
						
										<div className="col-lg-5 col-sm-5">
											<img src="img/slider-2.png" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</OwlCarousel>;
				</section>
							<section className="pf-details section">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s" >
							<div className="d-flex flex-column">
								<img className="img-fluid rounded align-self-end" src="img/24service.png" alt="website template image"/> 
							</div>
						</div>
						<div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s" >
							<div class="section-title">
								<h2>Get to Know Our 24-7 Medical Courier and Delivery Services Team</h2>
								<p>Redi Xpress Logistics is a New York and Ohio-based medical courier and e-commerce delivery services company that specializes in transporting medical supplies, medical prescriptions, labs, specimens, documents, and all other item-based delivery requests. We can deliver everything from floral arrangements and tires, to e-commerce purchases. We proudly operate on a 24-7 schedule, meaning you can contact us and place a request with our delivery team at any time of the day, from anywhere in the world. We take our rush delivery services incredibly seriously, providing you with peace of mind that your items are going to get to their destination quickly, swiftly, and efficiently. That’s our promise here at Redi Xpress Logistics. </p>
							</div>
						</div>
					</div>
				</div>
			</section>
			<div className="wcu_about container-fluid bg-primary overflow-hidden px-lg-0">
				<div className="container feature px-lg-0">
					<div className="row align-items-center">
						<div className="col-lg-6">
							<div className="section-title">
								<h2 className="text-white mb-4">Why Choose Us</h2>
								<p className="text-white mb-4 pb-2">There’s a reason we’re regarded as one of the fastest courier services in the country. Our team operates out of two states on a 24-7 basis, which means yes, we always have someone on staff who is reviewing delivery requests and forwarding them onto our fleet.  The moment we receive a request, we optimize the delivery route, contact our drivers, and schedule the rush delivery as quickly as possible. You don’t have any time to waste and neither do we – we prioritize efficiency in everything we do. As a team of expertly trained deliverers and drivers, we safeguard your delivery so that it arrives in pristine condition. That’s our guarantee.</p>
							</div>
						</div>
						<div className="col-lg-6 pe-lg-0" data-wow-delay="0.5s" >
							<img className="img-fluid" src="img/why-choose-us.png" alt="website template image" />
						</div>
					</div>
				</div>
			</div>
			<section className="driver-signup section">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-7 col-12">
							<div className="section-title">
								<h2>DELIVERY DRIVER WANTED</h2>
								<p>Are you a qualified commercial or delivery driver looking to become part of our fleet? Get in contact with our team today and we will schedule an interview ASAP.</p>
							</div>
						</div>
						<div className="col-lg-5 col-12">
							<img className="img-fluid rounded align-self-end" src="img/about-img.jpg" alt="website template image"/>
						</div>
					</div>
				</div>
			</section>
		
				<section className="call-action overlay">
					<div className="container">
						<div className="row">
							<div className="col-lg-12 col-md-12 col-12">
								<div className="content">
									<small>ABOUT DRIVERS</small>
									<h2>Need something delivered ASAP? Our experts will respond</h2>
									
									<div className="button mt-20">
										<a href="#" className="btn">REQUEST A QUOTE <i className="fa fa-long-arrow-right"></i></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
                <section className="services section">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<h2>WHAT WE DELIVER</h2>
									<p>We are more than just a delivery service- we are a team you can count on for fast transport</p>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-service">
									<i class="fa fa-cubes" aria-hidden="true"></i>
									<h4>Packages</h4>
									<p>Small, medium, large, oversize, overweight, and custom package requests</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-service">
									<i class="fa fa-building" aria-hidden="true"></i>
									<h4>Documents</h4>
									<p>Passport delivery and filling,Visa delivery and filling, Court filings, Real estate contracts, Court document retrieval, Sensitive paperwork, Custom document requests.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-service">
									<i class="fa fa-qrcode" aria-hidden="true"></i>
									<h4>Healthcare</h4>
									<p>Medical samples,specimen, equipment,devices and supplies.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-service">
									<i class="fa fa-user-circle-o" aria-hidden="true"></i>
									<h4>Floral</h4>
									<p>Wedding flowers, Funeral flowers, Event flowers, pop-upflowers, Custom floral requests.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-service">
									<i class="fa fa-crosshairs" aria-hidden="true"></i>
									<h4>E-commerce</h4>
									<p>Online purchase, Amazon packages, Dropshiping.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-service">
									<i class="fa fa-map-marker" aria-hidden="true"></i>
									<h4>Valuables</h4>
									<p>Artwork, Jewerly, Gems, Furniture, Glassware, Antiques, Furs, Rugs, Etc.</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className="driver-signup section">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-7 col-12">
							<div className="section-title">
								<h2>ABOUT OUR DRIVERS</h2>
								<p>We carefully vet, choose, and work with every single one of our drivers to ensure they can meet our commitments to efficient driving, safe deliveries, and stellar customer service. Our drivers come with a nationwide expertise that makes them some of the best in the game. It’s one thing to drive with speedy intent – but it’s a whole other thing to handle products, documents, and medical supplies with care. We look for drivers who can do both, which is why we are thorough when we make driver hires. Check out our fleet below.</p>
							</div>
						</div>
						<div className="col-lg-5 col-12">
							<img className="img-fluid rounded align-self-end" src="img/slider1.png" alt="website template image"/>
						</div>
					</div>
				</div>
			</section>
				<section className="call-action overlay">
					<div className="container">
						<div className="row">
							<div className="col-lg-12 col-md-12 col-12">
								<div className="content">
									<h2>Explore Our Services</h2>
									<p>Redixpress is a premier provider of nationwide pharmacy delivery services, specializing in efficient logistics solutions. We are dedicated to facilitating the smooth movement of goods within the industry, ensuring seamless global trade through reliable land transport.</p>
									<div className="button">
										<a href="#" className="btn">Explore More <i className="fa fa-long-arrow-right"></i></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className="blog section" id="blog">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<small>Blog post</small>
									<h2>Latest blog posts</h2>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="category">
												<span>Cargo</span>
												<span>Logistics</span>
											</div>
											<h2><Link to="/blog_detail">Helping Companies in  Their Green Transition</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
											<div className="date"><i class="fa fa-clock-o"></i> June 18, 2021 - <i>By admin</i></div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog2.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="category">
												<span>Cargo</span>
												<span>Logistics</span>
											</div>
											<h2><Link to="/blog_detail">Our Mission 2040: Zero  Emissions</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
											<div className="date"><i class="fa fa-clock-o"></i> June 18, 2021 - <i>By admin</i></div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog3.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="category">
												<span>Cargo</span>
												<span>Logistics</span>
											</div>
											<h2><Link to="/blog_detail">Key Logistics Trends in Life  Sciences 2021</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
											<div className="date"><i class="fa fa-clock-o"></i> June 18, 2021 - <i>By admin</i></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* <section className="Feautes section">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<h2>National Pharmacy Delivery Solutions by Redixpress</h2>
									<p>Redixpress leads the way in national logistics, supporting industries and facilitating international trade through efficient land transport.</p>
									<p>Our value-added services ensure uninterrupted flow of goods and optimize supply chains for seamless success.</p>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-4 col-12">
								<div className="single-features">
									<div className="signle-icon">
									<i className="fa fa-paper-plane-o" aria-hidden="true"></i>
									</div>
									<h3>National Sustainability Market Leader</h3>
									<p>We integrate new technological and digital advances to create value.</p>
								</div>
							</div>
							<div className="col-lg-4 col-12">
								<div className="single-features">
									<div className="signle-icon">
									<i className="fa fa-truck" aria-hidden="true"></i>
									</div>
									<h3>Relentless Productivity Driver</h3>
									<p>Consistently maximizes efficiency and output, driving relentless productivity</p>
								</div>
							</div>
							<div className="col-lg-4 col-12">
								<div className="single-features last">
									<div className="signle-icon">
									<i className="fa fa-cube" aria-hidden="true"></i>
									</div>
									<h3>Proud to deliver excellence. Every time</h3>
									<p>Unwavering dedication to delivering excellence, consistently.</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className="why-choose section" >
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<h2>What we provide</h2>
									<p>Here are the ingredients to our recipe for success</p>
								</div>
							</div>
						</div>
						<div className="row justify-content-center">
							<div className="col-lg-4 col-md-6 col-12">
								<div className="why_choose_box">
									<h3>Multi-route pick-up and delivery</h3>
									<p>Complicated delivery routes are a thing of the past, simply log in enter your pickup and drop off points and we will take care of the rest.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="why_choose_box">
									<h3>Warehousing</h3>
									<p>Redixpress is here to support a full manufacturing or distribution operation right at your disposal.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="why_choose_box">
									<h3>QR Code (proof of delivery)</h3>
									<p>Redixpress offers both security and peace of mind at your fingertips, through our QR code integration you receive instant confirmation of your medical delivery.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="why_choose_box">
									<h3>Dedicated Drivers</h3>
									<p>Your driver will keep you informed throughout the entire process and make sure your valuables arrive safe and sound.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="why_choose_box">
									<h3>Dispatching</h3>
									<p>We are passionate about making complex logistics processes simple, Our software automates and deploys on-demand medical couriers to give you the power of an entire fleet at your disposal.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="why_choose_box">
									<h3>Tracking Center</h3>
									<p>Stay up to date with the latest information on your packages, all in one convenient place.</p>
								</div>
							</div>
							<div className="col-lg-6 col-md-6 col-12">
								<div className="why_choose_box">
									<h3>Route Optimization</h3>
									<p>You want your medical delivery to get there fast, we want to help you. Our system analyzes and prepares a fully optimized delivery route in real time. Redixpress uses a series of algorithms to expedite the medical delivery process by dividing the operations between multiple drivers. whether it’s one destination or several, Redixpress’s got you covered.​</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className="what_we_do section">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<h2>What We Do</h2>
									<p>Reliable Couriers is the nation’s fastest courier and same day delivery service company.</p>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-4 col-md-6 col-12">
								<div className="what_we_do_box">
									<div className="what_we_do_img">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="what_we_do-body">
											<h2><Link to="/blog_detail">Medical Courier Services</Link></h2>
											<a href="#" className="btn">View Details</a>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="what_we_do_box">
									<div className="what_we_do_img">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="what_we_do-body">
											<h2><Link to="/blog_detail">Same Day Delivery</Link></h2>
											<a href="#" className="btn">View Details</a>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="what_we_do_box">
									<div className="what_we_do_img">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="what_we_do-body">
											<h2><Link to="/blog_detail">Next Flight Out Services</Link></h2>
											<a href="#" className="btn">View Details</a>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="what_we_do_box">
									<div className="what_we_do_img">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="what_we_do-body">
											<h2><Link to="/blog_detail">Legal Courier Services</Link></h2>
											<a href="#" className="btn">View Details</a>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="what_we_do_box">
									<div className="what_we_do_img">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="what_we_do-body">
											<h2><Link to="/blog_detail">Remote Office Pickup</Link></h2>
											<a href="#" className="btn">View Details</a>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="what_we_do_box">
									<div className="what_we_do_img">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="what_we_do-body">
											<h2><Link to="/blog_detail">Trade Shows Pickup & Delivery</Link></h2>
											<a href="#" className="btn">View Details</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className="what_we_deliver section">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<h2>What We Deliver</h2>
									<p>Reliable Couriers is more than just a delivery service.</p>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-4 col-12">
								<div className="single-features">
									<div className="signle-icon">
										<i className="fa fa-archive" aria-hidden="true"></i>
									</div>
									<h3>Packages</h3>
									<p>Small Packages, Medium Packages, Large Packages, Oversized & Overweight Packages</p>
								</div>
							</div>
							<div className="col-lg-4 col-12">
								<div className="single-features">
									<div className="signle-icon">
										<i className="fa fa-file-text" aria-hidden="true"></i>
									</div>
									<h3>Documents</h3>
									<p>Sensitive Documents, Passport Delivery and filing, Visa Delivery and Filing Court Filings, Real Estate Contracts, Court Document Retrieval</p>
								</div>
							</div>
							<div className="col-lg-4 col-12">
								<div className="single-features">
									<div className="signle-icon">
										<i className="fa fa-medkit" aria-hidden="true"></i>
									</div>
									<h3>Healthcare</h3>
									<p>Medical Specimen, Medical Samples, Medical Equipment, Medical Devices, Medical Supplies</p>
								</div>
							</div>
							<div className="col-lg-4 col-12">
								<div className="single-features last">
									<div className="signle-icon">
										<i className="fa fa-gift" aria-hidden="true"></i>
									</div>
									<h3>Perishables</h3>
									<p>Groceries, Cakes, Restaurant & Catering, Bakeries</p>
								</div>
							</div>
							<div className="col-lg-4 col-12">
								<div className="single-features last">
									<div className="signle-icon">
										<i className="fa fa-tag" aria-hidden="true"></i>
									</div>
									<h3>Retail</h3>
									<p>Store Purchases, Floral Arrangements, Gift Baskets, Inventory</p>
								</div>
							</div>
							<div className="col-lg-4 col-12">
								<div className="single-features last">
									<div className="signle-icon">
										<i className="fa fa-file-image-o" aria-hidden="true"></i>
									</div>
									<h3>Valuables</h3>
									<p>Art Work, Jewelry, Precious Metals, Furs, Antiques, Collectibles, Glassware</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className="blog section" id="blog">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<small>Blog post</small>
									<h2>Latest blog posts</h2>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="date">June 18, 2021 | By admin</div>
											<h2><Link to="/blog_detail">Helping Companies in  Their Green Transition</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="date">June 29, 2021 | By admin</div>
											<h2><Link to="/blog_detail">Our Mission 2040: Zero  Emissions</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-12">
								<div className="single-news">
									<div className="news-head">
										<img src="img/blog1.jpg" alt="#" />
									</div>
									<div className="news-body">
										<div className="news-content">
											<div className="date">June 29, 2021 | By admin</div>
											<h2><Link to="/blog_detail">Key Logistics Trends in Life  Sciences 2021</Link></h2>
											<p className="text">With the cargo business blasting, financier firms...</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<div className="drivers">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<small>Drivers</small>
									<h2>About Drivers</h2>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-3 col-md-6">
								<div className="team-item bg-light">
									<div className="overflow-hidden">
										<img className="img-fluid" src="img/author1.jpg" alt="website" />
									</div>
									<div className="text-center p-4">
										<h5 className="mb-0">Instructor Name</h5>
										<small>Designation</small>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="team-item bg-light">
									<div className="overflow-hidden">
										<img className="img-fluid" src="img/author2.jpg" alt="website" />
									</div>
									<div className="text-center p-4">
										<h5 className="mb-0">Instructor Name</h5>
										<small>Designation</small>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="team-item bg-light">
									<div className="overflow-hidden">
										<img className="img-fluid" src="img/author1.jpg" alt="website" />
									</div>
									<div className="text-center p-4">
										<h5 className="mb-0">Instructor Name</h5>
										<small>Designation</small>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="team-item bg-light">
									<div className="overflow-hidden">
										<img className="img-fluid" src="img/author2.jpg" alt="website" />
									</div>
									<div className="text-center p-4">
										<h5 className="mb-0">Instructor Name</h5>
										<small>Designation</small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<section className="appointment">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="section-title">
									<small>Request a quote</small>
									<h2>Tell us your needs, and our industry experts will respond</h2>
								</div>
							</div>
						</div>
						<div className="row justify-content-center">
							<div className="col-lg-7 col-md-12 col-12">
								<form className="form" action="#">
									<div className="row">
										<div className="col-lg-6 col-md-6 col-12">
											<div className="form-group">
												<input className="form-control" name="name" type="text" placeholder="First Name" />
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-12">
											<div className="form-group">
												<input className="form-control" name="name" type="text" placeholder="Last Name" />
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-12">
											<div className="form-group">
												<input className="form-control" name="email" type="email" placeholder="Email address" />
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-12">
											<div className="form-group">
												<input className="form-control" name="phone" type="text" placeholder="Phone Number" />
											</div>
										</div>
										<div className="col-lg-12 col-md-12 col-12">
											<div className="form-group">
												<div className="nice-select form-control wide" tabIndex="0"><span className="current">Role</span>
													<ul className="list">
														<li data-value="1" className="option selected ">Freight type</li>
														<li data-value="2" className="option">Freight type</li>
														<li data-value="3" className="option">Freight type</li>
														<li data-value="4" className="option">Freight type</li>
														<li data-value="5" className="option">Freight type</li>
													</ul>
												</div>
											</div>
										</div>
										<div className="col-lg-12 col-md-12 col-12">
											<div className="form-group">
												<textarea className="form-control" placeholder="How can we Help?"></textarea>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12 col-md-4 col-12">
											<div className="form-group">
												<div className="button">
													<button type="submit" className="btn">Request a quote</button>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</section> */}
			</div>
	     );
    }
}
export default Home;